import React from 'react';
import { ANY_OBJECT } from '@app/interfaces/interfaces';
import CellInputNode from '../CellInputNode/CellInputNode';
import { IUser } from '@app/interfaces/user';

interface EditableCellProps extends React.HTMLAttributes<HTMLElement> {
  editing: boolean;
  dataIndex: string;
  title: string;
  inputType: string;
  record: ANY_OBJECT;
  index: number;
  children: React.ReactNode;
  required: boolean;
  responsibleList: IUser[];
  buyerList: IUser[];
  sellerList: IUser[];
}

export const EditableCell: React.FC<EditableCellProps> = ({
  editing,
  dataIndex,
  title,
  inputType,
  children,
  required,
  record,
  responsibleList,
  buyerList,
  sellerList,
  ...restProps
}) => {
  return (
    <td {...restProps}>
      {editing ? (
        <CellInputNode
          inputType={inputType}
          dataIndex={dataIndex}
          record={record}
          title={title}
          required={required}
          responsibleList={responsibleList}
          buyerList={buyerList}
          sellerList={sellerList}
        />
      ) : (
        children
      )}
    </td>
  );
};
